<template>
	<div class="ui padded centered grid">
    <div class="row"></div>
    <div class="row">
      <div class="eight wide column" v-if="infoMessage === 'logout'">
        <div class="ui info message">You are successfully logged out.</div>
      </div>
      <div class="eight wide column" v-if="errorStatusCode === '401' || errorStatusCode === '403'">
        <div class="ui negative message">Sorry, you do not have the permissions to access this site. Please contact Healint if you believe this to be an error.</div>
      </div>
      <div class="eight wide column" v-if="errorStatusCode === '500'">
        <div class="ui negative message">Sorry, there's something wrong with the server at the moment. Please try again later.</div>
      </div>
    </div>
    <div class="four wide column">
      <div class="ui form" style="margin-top:2em;" id="user-credentials"
           @submit.prevent
           @keydown.enter.prevent>
        <center><div class="ui header">Log In to 3E Back Office</div></center>
        <br>
        <div class="field">
          <label>Migraine Buddy Email</label>
          <input id="email" name="email" type="email" placeholder="Email" v-model="currentUserEmail">
        </div>
        <div class="field">
          <label>Migraine Buddy Password</label>
          <input id="password" name="password" type="password" autocomplete="off" placeholder="Password" v-model="currentUserPassword">
        </div>

        <div class="ui fluid primary submit button" @click="authenticateUser">
          Log In
        </div>
        <div class="ui error message"></div>
      </div>

    </div>
	</div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
	export default {
    props: {
      //TODO: Write all the messages for all these different states
      errorStatusCode:{
        type: String
      },
      infoMessage: {
        type: String
      }
    },
		data() {
			return {
			  currentUserEmail: null,
        currentUserPassword: null
      }
		},
		computed: {
      ...mapState(['userAuthToken']),
    },
		methods: {
      ...mapActions(['updateUserProfile']),

      //TODO: Form validation for password and email

      initFormValidation() {
        $('#user-credentials')
          .form({
            fields: {
              'email': {
                identifier: 'email',
                rules: [
                  { type: 'empty' },
                  { type: 'email' }
                ]
              },
              'password': {
                identifier: 'password',
                rules: [
                  { type: 'empty'},
                 ]
              },
            },
            inline: true,
            keyboardShortcuts: false
          });
      },
      testLogin(){
        // FIXME
        // for development testing only
        if (process.env.NODE_ENV === "development") {
          this.$cookie.set('userAuthToken', process.env.ADMIN_AUTHTOKEN);
          this.$cookie.set('userId', 1231);
          this.$cookie.set('userEmail', this.currentUserEmail);

          let payload = {
            userAuthToken: process.env.ADMIN_AUTHTOKEN,
            userId: 77350,
            userEmail: 'test@healint.com'
          };
          this.updateUserProfile(payload).then(()=> {
            this.$router.push({ name: 'TabPatient'});
          });

        }
      },

      authenticateUser(){
        // Post call with password and email address and post to server
        // On success, set in cookies, then set in store, then redirect
        let validationStatus = $('#user-credentials').form('is valid');

        if (validationStatus === true) {
          let userCredentials = {
            "appId":"daily-service",
            "email": this.currentUserEmail,
            "password": this.currentUserPassword
          };

          this.$http.post(process.env.LOGIN_URL, userCredentials).then((response) => {

            this.$cookie.set('userAuthToken', response.body.result.authenticationToken);
            this.$cookie.set('userId', response.body.result.user.id);
            this.$cookie.set('userEmail', response.body.result.user.email);

            let payload = {
              userAuthToken: response.body.result.authenticationToken,
              userId: response.body.result.user.id,
              userEmail: response.body.result.user.email
            };
            this.updateUserProfile(payload).then(()=> {
              this.$router.push({ name: 'TabPatient'});
            });

          }, (error) => {
            if (error.status !== 401){
              Rollbar.error("Error in authentication", error);
              $('#user-credentials').form('add errors', ['Sorry, something unexpected has happened. Please check your internet connection and try again later.'])
            }
            else {
              $('#user-credentials').form('add errors', ['Cannot validate this account. Please check that your email and password are correct.'])
            }
          });
        }
        else {
          $('#user-credentials').form('validate form');
        }

      },

    },
    created(){
      this.$router.push({ name: 'TabPatient'});
    },
		mounted() {
      this.initFormValidation();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LogInPage.vue